export enum FeaturePermission {
  TICKET = 'TICKET',
  CREDIT_CARD = 'CREDIT_CARD',
  REPORT = 'REPORT',
  CONTROL_PANEL = 'CONTROL_PANEL/CONTROL_PANEL',
  STAFF = 'STAFF',
  CUSTOMER = 'CUSTOMER',
  GIFT_CARD = 'GIFT_CARD',
  EDIT_TICKET = 'EDIT_TICKET',
  VOID_TICKET = 'VOID_TICKET',
  REFUND_TICKET = 'REFUND_TICKET',
  DELETE_TICKET = 'DELETE_TICKET',
  SCHEDULE_STAFF = 'SCHEDULE_STAFF',
  SPLIT_MASTER = 'SPLIT_MASTER',
}

export enum FEATURE_KEYS {
  HOME_KEY_IN = 'HOME/HOME_KEY_IN', //x
  HOME_TIME_TRACKER = 'HOME/HOME_TIME_TRACKER', //x
  HOME_MANAGEMENT_TEAM = 'HOME/HOME_MANAGEMENT_TEAM', //x
  HOME_SORT_CHECK_IN = 'HOME/HOME_SORT_CHECK_IN', //x
  HOME_CASH_DEPOSIT = 'HOME/HOME_CASH_DEPOSIT', //x
  CASHIER_VOID_TICKET = 'CASHIER/CASHIER_VOID_TICKET', //x
  CASHIER_DISCOUNT_ITEM = 'CASHIER/CASHIER_DISCOUNT_ITEM', //x
  CASHIER_DISCOUNT_TICKET = 'CASHIER/CASHIER_DISCOUNT_TICKET', //x
  CASHIER_CASH_PAYMENT = 'CASHIER/CASHIER_CASH_PAYMENT', //x
  MULTIPLE_PAY = 'CASHIER/MULTIPLE_PAY', //x
  CASHIER_TIP = 'CASHIER/CASHIER_TIP', //x
  CREDIT_CARD_VIEW = 'CREDIT_CARD/CREDIT_CARD_VIEW', //x
  CREDIT_CARD_REFUND = 'CREDIT_CARD/CREDIT_CARD_REFUND', //x
  CREDIT_CARD_VOID = 'CREDIT_CARD/CREDIT_CARD_VOID', //x
  CREDIT_CARD_ADJUST_TIP = 'CREDIT_CARD/CREDIT_CARD_ADJUST_TIP', //x
  CREDIT_CARD_DELETE = 'CREDIT_CARD/CREDIT_CARD_DELETE', //x
  TICKET_VIEW = 'TICKET/TICKET_VIEW', // x
  TICKET_REFUND = 'TICKET/TICKET_REFUND', //x
  TICKET_VOID = 'TICKET/TICKET_VOID', //x
  TICKET_ADJUST_TIP = 'TICKET/TICKET_ADJUST_TIP',//x
  TICKET_EDIT_TICKET = 'TICKET/TICKET_EDIT_TICKET', //x
  TICKET_DELETE_TICKET = 'TICKET/TICKET_DELETE_TICKET', //x
  REPORT_VIEW = 'REPORT/REPORT_VIEW', //x
  REPORT_REVENUE = 'REPORT/REPORT_REVENUE', //x
  REPORT_INCOME = 'REPORT/REPORT_INCOME', //x
  REPORT_SERVICE = 'REPORT/REPORT_SERVICE', //x
  REPORT_PRODUCT = 'REPORT/REPORT_PRODUCT', //x
  REPORT_PAYROLL = 'REPORT/REPORT_PAYROLL', //x
  REPORT_TIME_CLOCK = 'REPORT/REPORT_TIME_CLOCK',//x
  REPORT_CASH_DEPOSIT = 'REPORT/REPORT_CASH_DEPOSIT',//x
  REPORT_REVIEW = 'REPORT/REPORT_REVIEW', //x
  REPORT_CONSENT_FORM = 'REPORT/REPORT_CONSENT_FORM', //x
  QUICK_VIEW_VIEW = 'QUICK_VIEW/QUICK_VIEW_VIEW', //x
  QUICK_VIEW_SMS = 'QUICK_VIEW/QUICK_VIEW_SMS',//x
  QUICK_VIEW_EMAIL = 'QUICK_VIEW/QUICK_VIEW_EMAIL', //x
  QUICK_VIEW_PRINT = 'QUICK_VIEW/QUICK_VIEW_PRINT', //x
  CASH_DRAWER_OPEN = 'CASH_DRAWER/CASH_DRAWER_OPEN', //x
  TURN_VIEW = 'TURN/TURN_VIEW', //x
  TURN_SETTING = 'TURN/TURN_SETTING', //x
  TURN_RE_ORDER = 'TURN/TURN_RE_ORDER', //x
  TURN_CLEAR = 'TURN/TURN_CLEAR',//x
  TURN_EDIT = 'TURN/TURN_EDIT', //x
  APPOINTMENT_VIEW = 'APPOINTMENT/APPOINTMENT_VIEW', //x
  APPOINTMENT_BOOKING = 'APPOINTMENT/APPOINTMENT_BOOKING', //x
  APPOINTMENT_EDIT = 'APPOINTMENT/APPOINTMENT_EDIT', //x
  APPOINTMENT_SETTING = 'APPOINTMENT/APPOINTMENT_SETTING', //x
  APPOINTMENT_DRAG = 'APPOINTMENT/APPOINTMENT_DRAG', //x
  GIFT_CARD_VIEW = 'GIFT_CARD/GIFT_CARD_VIEW', //x
  GIFT_CARD_ADD = 'GIFT_CARD/GIFT_CARD_ADD', //x
  GIFT_CARD_RESET = 'GIFT_CARD/GIFT_CARD_RESET',//x
  GIFT_CARD_REDEEM = 'GIFT_CARD/GIFT_CARD_REDEEM', //x
  GIFT_CARD_DELETE = 'GIFT_CARD/GIFT_CARD_DELETE', //x
  GIFT_CARD_EDIT = 'GIFT_CARD/GIFT_CARD_EDIT', //x
  GIFT_CARD_RESEND = 'GIFT_CARD/GIFT_CARD_RESEND',//x
  CUSTOMER_VIEW = 'CUSTOMER/CUSTOMER_VIEW', //x
  CUSTOMER_ADD = 'CUSTOMER/CUSTOMER_ADD', //x
  CUSTOMER_EDIT = 'CUSTOMER/CUSTOMER_EDIT', //x
  CUSTOMER_UPDATE_POINT = 'CUSTOMER/CUSTOMER_UPDATE_POINT', //x
  CUSTOMER_DELETE = 'CUSTOMER/CUSTOMER_DELETE', //x
  STAFF_VIEW = 'STAFF/STAFF_VIEW', //x
  STAFF_ADD = 'STAFF/STAFF_ADD', //x
  STAFF_EDIT = 'STAFF/STAFF_EDIT', //x
  STAFF_DELETE = 'STAFF/STAFF_DELETE', //x
  STAFF_SECURITY = 'STAFF/STAFF_SECURITY', //x
  STAFF_SALARY = 'STAFF/STAFF_SALARY', //x
  STAFF_SPECIALIZE = 'STAFF/STAFF_SPECIALIZE', //x
  STAFF_SCHEDULE = 'STAFF/STAFF_SCHEDULE', //x
  STAFF_IMAGES = 'STAFF/STAFF_IMAGES', //x
  STAFF_OVERRIDETIMEOFF = 'STAFF/STAFF_OVERRIDETIMEOFF', //x
  STAFF_REORDER_BOOKING = 'STAFF/STAFF_REORDER_BOOKING', //x
  CONTROL_PANEL_VIEW = 'CONTROL_PANEL/CONTROL_PANEL_VIEW', //x
  CONTROL_PANEL_SERVICE = 'CONTROL_PANEL/CONTROL_PANEL_SERVICE',//x
  CONTROL_PANEL_SIMPLE_MENU = 'CONTROL_PANEL/CONTROL_PANEL_SIMPLE_MENU', //x
  CONTROL_PANEL_PRODUCT = 'CONTROL_PANEL/CONTROL_PANEL_PRODUCT', //x
  CONTROL_PANEL_VIP = 'CONTROL_PANEL/CONTROL_PANEL_VIP', //x 
  CONTROL_PANEL_QUICK_PAY = 'CONTROL_PANEL/CONTROL_PANEL_QUICK_PAY', //x
  CONTROL_PANEL_TURN = 'CONTROL_PANEL/CONTROL_PANEL_TURN', //x 
  CONTROL_PANEL_TURN_QUICK_PAY = 'CONTROL_PANEL/CONTROL_PANEL_TURN_QUICK_PAY', //x
  CONTROL_PANEL_TURN_LATE_FOR_WORK = 'CONTROL_PANEL/CONTROL_PANEL_TURN_LATE_FOR_WORK', //x
  CONTROL_PANEL_TURN_APPOINTMENT = 'CONTROL_PANEL/CONTROL_PANEL_TURN_APPOINTMENT', //x
  CONTROL_PANEL_CONGIGURATIONS = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS',//x
  CONTROL_PANEL_CONGIGURATIONS_TAX = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_TAX', //x
  CONTROL_PANEL_CONGIGURATIONS_DISCOUNT = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_DISCOUNT', //x
  CONTROL_PANEL_CONGIGURATIONS_TIP_OPTIONS = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_TIP_OPTIONS', //x
  CONTROL_PANEL_CONGIGURATIONS_LOYALTY = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_LOYALTY', //x
  CONTROL_PANEL_CONGIGURATIONS_REFERRAL = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_REFERRAL', //x
  CONTROL_PANEL_CONGIGURATIONS_CHECK = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_CHECK', //x
  CONTROL_PANEL_CONGIGURATIONS_GIFT_CARD = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_GIFT_CARD', //x
  CONTROL_PANEL_CONGIGURATIONS_CONSENT = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_CONSENT', //x
  CONTROL_PANEL_CONGIGURATIONS_WORKING_TIME = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_WORKING_TIME', //x
  CONTROL_PANEL_CONGIGURATIONS_CLEANING_FEE = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_CLEANING_FEE', //x
  CONTROL_PANEL_CONGIGURATIONS_PRODUCT_TAX = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_PRODUCT_TAX', //x
  CONTROL_PANEL_CONGIGURATIONS_PRINT_CHECK = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_PRINT_CHECK', //x
  CONTROL_PANEL_CONGIGURATIONS_NOTI = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_NOTI', //x
  CONTROL_PANEL_CONGIGURATIONS_SEND_CPA = 'CONTROL_PANEL/CONTROL_PANEL_CONGIGURATIONS_SEND_CPA', //x
}
